<template lang="pug">
  footer.footer.bg-black
    ul.d-md-flex
      li.nav-item
        a.nav-link.text-white(
          :href="corpUrl")
          | {{$t('footer.company')}}
      li.nav-item
        router-link.nav-link.text-white(
          :to="{name: 'terms.index'}"
          @click="backToTop")
          | {{$t('footer.terms')}}
      li.nav-item
        router-link.nav-link.text-white(
          :to="{name: 'policy.index'}"
          @click="backToTop")
          | {{$t('footer.policy')}}
      li.nav-item
        router-link.nav-link.text-white(
          :to="{name: 'tradelaw.index'}"
          @click="backToTop")
          | {{$t('footer.tradelaw')}}
      li.nav-item
        router-link.nav-link.text-white(
          :to="{name: 'faq.index'}"
          @click="backToTop")
          | {{$t('footer.faq')}}
      li.nav-item
        router-link.nav-link.text-white(
          :to="{name: 'contact.index'}"
          @click="backToTop")
          | {{$t('footer.contact')}}

    .text-center
      p.footer-copy.text-white
        | {{$t('footer.copy')}}

    //- a.toTop(@click="backToTop")
      span.icon_totop
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'base-footer',
    methods: {
      backToTop() {
        this.$scrollTo('html')
      }
    },
    computed: {
      ...mapGetters('layout', ['layoutHeader']),
      termsRoute() {
        return (this.layoutHeader === 'client') ? 'client.terms' : 'termsService.index'
      },
      corpUrl() {
        if (process.env.NODE_ENV === 'production') {
          return 'https://corp.zatsudan.com/'
        }
          return 'https://corp.stg.zatsudan-work.net/'
      }
    }
  }
</script>
